import "./AboutMe.css";

const AboutMe = () => {
    return (
        <div>
            <h1>ABOUT ME</h1>
            <h3>Hello stranger!</h3>
            <p>Or maybe you're not a stranger. Either way, welcome to my personal website! My name is <span id="name">Jordan D'Souza</span>, although I also
               use the alias "JRDN" as well. I created this website demonstrate and show off the incredible capabilities of coding and
               programming. This About Me page is only the start - throughout the entire website, you will find several nods to the many
               hobbies and interests that I enjoy. For those who know me personally, there are many little "easter eggs"
               scattered throughout that I'm sure you will enjoy (SMILEY FACE).
            </p>
        </div>
    );
}

export default AboutMe;